window.addEventListener('load', () => {
  //document.querySelector('.video-carousel__container').style.display = 'block'

  var elem = document.querySelector('.video-carousel__slider');
  if (window.matchMedia("(max-width: 576px)").matches) {
    var flkty = new Flickity(elem, {
      // options
      cellAlign: 'left',
      contain: true,
      autoPlay: 6000,
      prevNextButtons: false,
      wrapAround: true,
      groupCell: true
    });
  } else {
    var flkty = new Flickity(elem, {
      // options
      cellAlign: 'center',
      contain: true,
      autoPlay: 6000,
      prevNextButtons: false,
      wrapAround: true,
      groupCell: true
    });
  }
  flkty.on('dragStart', () => flkty.slider.style.pointerEvents = 'none');
  flkty.on('dragEnd', () => flkty.slider.style.pointerEvents = 'auto');
  document.querySelectorAll('.video-carousel__video').forEach(video => {
    video.addEventListener('click', () => {
      document.querySelectorAll('.video-carousel__video--is-playing').forEach(vid => {
        vid.pause(), vid.nextElementSibling.classList.remove('video-carousel__player--is-hidden');
      });
      video.classList.toggle('video-carousel__video--is-playing');
      if (video.classList.contains('video-carousel__video--is-playing')) {
        video.play();
        video.nextElementSibling.classList.add('video-carousel__player--is-hidden');
      } else {
        video.pause();
        video.nextElementSibling.classList.remove('video-carousel__player--is-hidden');
      }
    });
  });
});